<span class="_content">
  <ng-content></ng-content>
</span>
@if (icon) {
  <icms-icon
    class="_icon"
  [icon]="icon"></icms-icon>
}
@if (isBusy) {
  <div
    class="_loader">
    <icms-loader [dfs]="'d:block'"></icms-loader>
  </div>
}